<template>
  <div
    class="columns"
    :class="{ 'columns--stacked-mobile': isStackedOnMobile }"
  >
    <slot />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'CoreColumns',
    props: {
      isStackedOnMobile: {
        type: Boolean as PropType<boolean>,
        default: true,
      },
    },
  });
</script>

<style lang="scss">
  .columns {
    display: flex;

    .column {
      &:not(:last-child) {
        margin-right: 24px;
        @include tablet {
          margin-right: $spacing-8;
        }
      }
    }

    &--stacked-mobile {
      display: block;

      @include tablet {
        display: flex;
      }

      .column:not(:last-child) {
        margin-bottom: $spacing-6;
        margin-right: 0;

        @include tablet {
          margin-right: $spacing-8;
        }
      }

      .column {
        flex-basis: 50%;

        @include tablet {
          width: calc(50% - $spacing-8 / 2);
        }
      }
    }

    .column {
      flex-basis: 100%;
    }
  }
</style>
